import ShowContainer from "@/views/packing_house/production/uniq_final_packing_list/ShowContainer.vue";
import ShowContainerResumeTab from "@/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/Container.vue";
import ShowContainerPalletsTab from "@/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/Pallets.vue";
import ShowContainerPackagesTab from "@/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/Packages.vue";
import ShowContainerCrossTab from "@/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/CrossData.vue";
import ShowContainerSizesByPallet from "@/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/SizesByPallet.vue";
import ListProcesses from "@/views/packing_house/production/uniq_final_packing_list/ListProcesses.vue";
import ShowProcess from "@/views/packing_house/production/uniq_final_packing_list/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/packing_house/production/uniq_final_packing_list/show_process/Containers.vue";
import ShowProcessPackagesFromStock from "@/components/views/packing_house/production/uniq_final_packing_list/show_process/PackagesFromStock.vue";
import NewPackageGroup from "@/views/packing_house/production/uniq_final_packing_list/NewPackageGroup.vue";
import EditPackageGroup from "@/views/packing_house/production/uniq_final_packing_list/EditPackageGroup.vue";
import ClonePackageGroup from "@/views/packing_house/production/uniq_final_packing_list/ClonePackageGroup.vue";
import MovePackageGroup from "@/views/packing_house/production/uniq_final_packing_list/MovePackageGroup.vue";
import NewPackages from "@/views/packing_house/production/uniq_final_packing_list/NewPackages.vue";
import EditPackages from "@/views/packing_house/production/uniq_final_packing_list/EditPackages.vue";
import UploadPackingList from "@/views/packing_house/production/uniq_final_packing_list/UploadPackingList.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "production",
  permission: "uniq_final_packing_list",
});

export default [
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id",
    name: routeName("show_container"),
    redirect: { name: routeName("show_container_pallets") },
    component: ShowContainer,
    props: true,
    meta: META,
    children: [
      {
        path: "resume",
        name: routeName("show_container_resume"),
        component: ShowContainerResumeTab,
        props: true,
        meta: META,
      },
      {
        path: "pallets",
        name: routeName("show_container_pallets"),
        component: ShowContainerPalletsTab,
        props: true,
        meta: META,
      },
      {
        path: "sizes_by_pallet",
        name: routeName("show_container_sizes_by_pallet"),
        component: ShowContainerSizesByPallet,
        props: true,
        meta: META,
      },
      {
        path: "packages",
        name: routeName("show_container_packages"),
        component: ShowContainerPackagesTab,
        props: true,
        meta: META,
      },
      {
        path: "cross",
        name: routeName("show_container_cross"),
        component: ShowContainerCrossTab,
        props: true,
        meta: META,
      },
    ]
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id/new_packages",
    name: routeName("new_packages"),
    component: NewPackages,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id/o/:organization_id?/p/:producer_id?/edit_packages",
    name: routeName("edit_packages"),
    component: EditPackages,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/show_process/:packing_house_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        component: ShowProcessContainers,
        props: true,
        meta: META,
      },
      {
        path: "packages_from_stock",
        name: routeName("show_process_packages_from_stock"),
        component: ShowProcessPackagesFromStock,
        props: true,
        meta: META,
      }
    ]
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id/package_groups/new",
    name: routeName("new_package_group"),
    component: NewPackageGroup,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id/package_groups/:package_group_id/edit",
    name: routeName("edit_package_group"),
    component: EditPackageGroup,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id/package_groups/:package_group_id/clone",
    name: routeName("clone_package_group"),
    component: ClonePackageGroup,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id/package_groups/:package_group_id/move",
    name: routeName("move_package_group"),
    component: MovePackageGroup,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/production/uniq_final_packing_list/packing_house_process/:packing_house_process_id/container/:container_id/upload_packing_list/:packing_list_format",
    name: routeName("upload_packing_list"),
    component: UploadPackingList,
    props: true,
    meta: META
  }
];
